var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-collapse",
    {
      staticClass: "evaluation-card",
      attrs: { animation: "slide", open: _vm.isOpen, "data-cy": "gops-data" },
      scopedSlots: _vm._u([
        {
          key: "trigger",
          fn: function ({ open }) {
            return [
              _c(
                "header",
                {
                  staticClass: "card-header",
                  attrs: { role: "button", "aria-expanded": open.toString() },
                },
                [
                  _c("p", { staticClass: "card-header-title" }, [
                    _vm._v(" GOPs asociados "),
                  ]),
                  _c(
                    "a",
                    { staticClass: "card-header-icon" },
                    [
                      _c("b-icon", {
                        attrs: { icon: open ? "minus" : "plus" },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          },
        },
      ]),
    },
    [
      _c("section", { staticClass: "card-block p-0 pt-1" }, [
        _c("div", { staticClass: "subcard is-gray" }, [
          _c(
            "div",
            { staticClass: "subcard-header" },
            [
              _c("p", { staticClass: "header-title" }, [
                _vm._v("Gastos operacionales"),
              ]),
              _c("b-button", {
                staticClass: "header-icon",
                attrs: {
                  size: "is-small",
                  "icon-left": _vm.propertiesValues ? "angle-up" : "angle-down",
                },
                on: { click: _vm.togglePropertiesValues },
              }),
            ],
            1
          ),
          _vm.propertiesValues
            ? _c(
                "div",
                { staticClass: "subcard-content fields-has-text-right" },
                [
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Total de gastos operacionales",
                      placeholder: "Ingresa valor en UF",
                      prefix: "UF",
                      size: "is-small",
                      "prefix-position": "left",
                    },
                    model: {
                      value: _vm.simulation.offerResponse.operationalExpenses,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerResponse,
                          "operationalExpenses",
                          $$v
                        )
                      },
                      expression:
                        "simulation.offerResponse.operationalExpenses",
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Estudio de títulos",
                      placeholder: "Ingresa valor en UF",
                      prefix: "UF",
                      size: "is-small",
                      "prefix-position": "left",
                    },
                    model: {
                      value: _vm.simulation.offerResponse.titleStudyExpenses,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerResponse,
                          "titleStudyExpenses",
                          $$v
                        )
                      },
                      expression: "simulation.offerResponse.titleStudyExpenses",
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Tasación",
                      placeholder: "Ingresa valor en UF",
                      prefix: "UF",
                      size: "is-small",
                      "prefix-position": "left",
                    },
                    model: {
                      value: _vm.simulation.offerResponse.appraisalExpenses,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerResponse,
                          "appraisalExpenses",
                          $$v
                        )
                      },
                      expression: "simulation.offerResponse.appraisalExpenses",
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Escrituración",
                      placeholder: "Ingresa valor en UF",
                      prefix: "UF",
                      size: "is-small",
                      "prefix-position": "left",
                    },
                    model: {
                      value: _vm.simulation.offerResponse.deedExpenses,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerResponse,
                          "deedExpenses",
                          $$v
                        )
                      },
                      expression: "simulation.offerResponse.deedExpenses",
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Notaria",
                      placeholder: "Ingresa valor en UF",
                      prefix: "UF",
                      size: "is-small",
                      "prefix-position": "left",
                    },
                    model: {
                      value: _vm.simulation.offerResponse.notaryExpenses,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerResponse,
                          "notaryExpenses",
                          $$v
                        )
                      },
                      expression: "simulation.offerResponse.notaryExpenses",
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Inscripción",
                      placeholder: "Ingresa valor",
                      prefix: "%",
                      size: "is-small",
                      "prefix-position": "left",
                    },
                    model: {
                      value: _vm.simulation.offerResponse.registrationExpenses,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerResponse,
                          "registrationExpenses",
                          $$v
                        )
                      },
                      expression:
                        "simulation.offerResponse.registrationExpenses",
                    },
                  }),
                  _c("BInputExpanded", {
                    attrs: {
                      disabled: _vm.readOnly,
                      label: "Impuesto al mutuo",
                      placeholder: "Ingresa valor",
                      prefix: "%",
                      size: "is-small",
                      "prefix-position": "left",
                    },
                    model: {
                      value: _vm.simulation.offerResponse.creditTaxExpenses,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.simulation.offerResponse,
                          "creditTaxExpenses",
                          $$v
                        )
                      },
                      expression: "simulation.offerResponse.creditTaxExpenses",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]),
        _c(
          "div",
          { staticClass: "subcard" },
          [
            _c("BInputExpanded", {
              attrs: {
                value: _vm.calculateRebajasConvenios(),
                disabled: _vm.readOnly,
                label: "Rebajas o convenios",
                placeholder: "Ingresa valor en UF",
                prefix: "UF",
                size: "is-small",
                "prefix-position": "left",
              },
            }),
            _c("BInputExpanded", {
              attrs: {
                disabled: _vm.readOnly,
                label: "Financiados en crédito",
                placeholder: "Ingresa valor en UF",
                prefix: "UF",
                size: "is-small",
                "prefix-position": "left",
              },
              model: {
                value: _vm.simulation.offerResponse.operationalExpensesFinanced,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.simulation.offerResponse,
                    "operationalExpensesFinanced",
                    $$v
                  )
                },
                expression:
                  "simulation.offerResponse.operationalExpensesFinanced",
              },
            }),
            _c("BInputExpanded", {
              attrs: {
                disabled: _vm.readOnly,
                label: "Cuota fuera de crédito",
                placeholder: "Ingresa valor en UF",
                prefix: "UF",
                size: "is-small",
                "prefix-position": "left",
              },
              model: {
                value: _vm.simulation.offerResponse.operationalExpensesFee,
                callback: function ($$v) {
                  _vm.$set(
                    _vm.simulation.offerResponse,
                    "operationalExpensesFee",
                    $$v
                  )
                },
                expression: "simulation.offerResponse.operationalExpensesFee",
              },
            }),
            _c("BInputExpanded", {
              attrs: {
                disabled: _vm.readOnly,
                label: "A depositar por cliente",
                placeholder: "Ingresa valor en UF",
                prefix: "UF",
                size: "is-small",
                "prefix-position": "left",
              },
              model: {
                value: _vm.depositedByClient,
                callback: function ($$v) {
                  _vm.depositedByClient = $$v
                },
                expression: "depositedByClient",
              },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }